import React,{useEffect,useState} from 'react'

import axios from 'axios'

import Select from "react-select";

const Dropdownget = () => {





 

  useEffect(()=>{




   

    getVenture()

  }, [])

  const [allVentures,setAllusers]= useState([])

  const [Options,setOptions]= useState('')

  const [AOptions,setAOptions]= useState('')

  const [BOptions,setBOptions]= useState('')

  function getVenture(){




 

    fetch(`https://localhost:44312/api/Venture/GetVentures`, {

     

    method:'GET',

 

      headers : {

 

        "Content-type": "application/json",

 

        "Accept": "application/json",

 

 

        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

      },

 

      //body:JSON.stringify(data)

 

    }).then(response => response.json())

    .then(data => {

      console.log("Data",data)

      setAllusers(data)

      localStorage.setItem("EditPandaVenture",JSON.stringify(data))

   

   

     





       let userName = EditData.map((item) => item.ventureName);




       let Id = EditData.map((item) => item.id);

       let Link = EditData.map((item) => item.ventureLogo);

       setOptions(userName);

       setAOptions(Id)




       setBOptions(Link)

    });

 

    console.log("check",allVentures)




  }  

  let AOption=""

  for(let i=0;i<AOptions.length;i++){




    AOption += AOptions[i]

 

    }

    let EditData = JSON.parse(localStorage.getItem("EditPandaVenture"));

 

    // //  i++;

    // const optionList = EditData.map((response) => ({

    //   "value" : response.ventureLogo,

    //   "label" : response.ventureName,

    //   "name" : response.ventureLogo

    // }))

    const options = allVentures.map(item => {

      return {

          label: item.ventureName,

          value: item.ventureLogo,
          name:item.ventureId    

      }

  })

  // const optionList = [

 




  //   { value: AOptions[0], label: Options[0],name: BOptions[0]},

  //     { value: AOptions[1], label: Options[1],name: BOptions[1]},

  //    { value: AOptions[2], label: Options[2] ,name: BOptions[2]},

  //    { value: AOptions[3], label: Options[3] ,name: BOptions[3]},

  //    { value: AOptions[4], label: Options[4] ,name: BOptions[4]},

  //    { value: AOptions[5], label: Options[5] ,name: BOptions[5]}

   

 

  // ];

  const [selectedOptions, setSelectedOptions] = useState();




 

  function handleSelect(data) {

    setSelectedOptions(data);

  }





  function SelectParticular(){

    var assign = selectedOptions.map(((item) => item.name));

    var assignA = selectedOptions.map(((item) => item.value));
    var assignB = selectedOptions.map(((item) => item.label));

    console.log(assign)
    console.log(assignA)
    console.log(assignB)

    let section = assign.toString();
    let sectionA = assignA.toString();
    let sectionB = assignB.toString();
    console.log(section)
    console.log(sectionA)
    console.log(sectionB)
   }

return (

    <div>

      <form onSubmit={SelectParticular}>

       <div><Select  

       

       className="dropdown"

   options={options}

   id="OatAselect"

   placeholder="Select Section"

   value={selectedOptions}

   onChange={handleSelect}

   isSearchable={true}

   isMulti

   isClearable

 /></div>





 <button type='submit'>ok</button>

      </form>

    </div>

  )

}




export default Dropdownget


